import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouter } from 'hooks/useRouter'
import React from 'react'
import Permissions from 'types/Permissions'

import { UnificacaoCadastroView } from './UnificacaoCadastroView'

export default function UnificacaoCadastroRootView() {
  const { match } = useRouter()
  return (
    <>
      <Breadcrumb title='Unificação de cadastros' />
      <PecSwitch>
        <PrivateRoute
          exact
          path={`${match.url}`}
          component={UnificacaoCadastroView}
          permission={Permissions.gestaoDeCadastrosDeCidadao.unificacaoDeCadastros}
        />
      </PecSwitch>
    </>
  )
}
